import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';

import * as IBooks from '../../../../../../../interfaces/merchants/resources/books';
import css from './BooksCalendarTimeTable.module.scss';

import Icon from '../../../../../../../atoms/icons/Icon';

interface Props {
  loading: boolean;
  postable: boolean;
  events: {
    checkinTimes: string[];
    dates: { [date: string]: IBooks.DateTimeSlot };
  };
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const BooksCalendarTimeTable = ({
  loading,
  postable,
  events,
  onClick,
}: Props) => {
  const classes = classNames(css.BooksCalendarTimeTable);
  const intl = useIntl();

  return (
    <div className={classes}>
      <div className={css.BooksCalendarTimeTable__Title}>
        {events.checkinTimes.map((checkinTime, index) => (
          <div
            className={css.BooksCalendarTimeTable__TitleMinute}
            key={index}
            data-style={checkinTime.endsWith('00') && 'zeroMinutes'}
          >
            {checkinTime}
          </div>
        ))}
      </div>

      <div className={css.BooksCalendarTimeTable__Content}>
        {Object.entries(events.dates).map(([date, timeSlot]) => (
          <div className={css.BooksCalendarTimeTable__DayLine} key={date}>
            {/* NOTE: 受付時間？をこえるとその日の枠が全部閉じる */}
            {timeSlot.class === 'inactive' && (
              <div
                className={css.BooksCalendarTimeTable__Minute}
                data-style="holiday"
              >
                <div className={css.BooksCalendarTimeTable__Close} />
              </div>
            )}

            {timeSlot.class === 'holiday' && (
              <div
                className={css.BooksCalendarTimeTable__Minute}
                data-style="holiday"
              >
                <div
                  className={css.BooksCalendarTimeTable__Close}
                  data-style={events.checkinTimes.length <= 3 && 'short'}
                >
                  {intl.formatMessage({ id: 'books.calendar.holiday' })}
                </div>
              </div>
            )}

            {timeSlot.class === 'active' &&
              timeSlot.availabilities.map((a, i) => (
                <div
                  key={i}
                  className={css.BooksCalendarTimeTable__Minute}
                  data-style={a.value.endsWith('00') && 'zeroMinutes'}
                >
                  {loading ? (
                    <span />
                  ) : a.state === 'available' ? (
                    <button
                      type="button"
                      disabled={!postable}
                      className={css.BooksCalendarTimeTable__Button}
                      value={a.time}
                      onClick={onClick}
                      data-e2e={'availableCalendarButton'}
                    >
                      <Icon
                        className={css.BooksCalendarTimeTable__Icon}
                        name="calendar-ok"
                      />
                    </button>
                  ) : a.state === 'occupied' ? (
                    <span className={css.BooksCalendarTimeTable__Cross}>
                      <Icon
                        className={css.BooksCalendarTimeTable__Icon}
                        name="calendar-ng"
                      />
                    </span>
                  ) : (
                    <span />
                  )}
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BooksCalendarTimeTable;
